class BrowserPageController implements ng.IComponentController {

    constructor(private deviceDetector: any) {
        'ngInject';
        // console.log('CrmController');
    }
}

export const browserPageComponent : ng.IComponentOptions = {
    controller : BrowserPageController,
    template : require('./browser.page.html')
};



// WEBPACK FOOTER //
// ./src/app/main/browser.page.component.ts